import { useState, useCallback, useEffect } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import TagManager from 'react-gtm-module';

// Pages
import GolferInfo from './components/GolferInfo';
import GolferPreferences from './components/GolferPreferences';
import InBag from './components/InBag';
import ShotSelection from './components/SelectShots';
import Fitting from './components/Fitting';
import WhyGrinds from './components/WhyGrinds';
import RankShots from './components/RankShots';
import FittingProcess from './components/FittingProcesss';
import Auth from './components/Auth';
import FitterHistory from './components/FitterHistory';
import CreateAccount from './components/CreateAccount';
import ForgotPassword from './components/ForgotPassword';
import RefreshVersion from './components/RefreshVersion';
import SetupInstructions from './components/SetupInstructions';
import TMLog from './components/TMLog';

import './App.css';

function App() {
    const [timeoutId, setTimeoutId] = useState(-1);
    const [showForm, setShowForm] = useState(false);

    useEffect((): void => {
        const tagManagerArgs = {
            gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER || ""
        }
        TagManager.initialize(tagManagerArgs);
    }, [])

    const startTimeout = useCallback(() => {
        clearTimeout(timeoutId);
        const newTimeoutId = window.setTimeout(() => {
            setShowForm(false);
        }, 100 * 60 * 1000);
        setTimeoutId(newTimeoutId);
    }, [])

    const resetTimeout = useCallback(() => {
        setShowForm(true);
        clearTimeout(timeoutId);
        startTimeout();
    }, []);

    return (
        <div className="App">
            <Routes>
                <Route path="/apps/wedgefitting" element={<Auth />} />
                <Route path="/apps/wedgefitting/fitterlogin" element={<Navigate to={"/apps/wedgefitting"} />} />
                <Route path="/apps/wedgefitting/golferinfo" element={<GolferInfo />} />
                <Route path="/apps/wedgefitting/golferpreferences" element={<GolferPreferences />} />
                <Route path="/apps/wedgefitting/inbag" element={<InBag />} />
                <Route path='/apps/wedgefitting/selectshots' element={<ShotSelection />} />
                <Route path="/apps/wedgefitting/rankshots" element={<RankShots resettimeout={resetTimeout} />} />
                <Route path="/apps/wedgefitting/fitting" element={<Fitting resettimeout={resetTimeout} />} />
                <Route path="/apps/wedgefitting/whygrinds" element={<WhyGrinds />} />
                <Route path="/apps/wedgefitting/fittingprocess" element={<FittingProcess />} />
                <Route path="/apps/wedgefitting/fitterhistory" element={<FitterHistory />} />
                <Route path="/apps/wedgefitting/createaccount" element={<CreateAccount />} />
                <Route path="/apps/wedgefitting/forgotpassword" element={<ForgotPassword />} />
                <Route path="/apps/wedgefitting/refreshversion" element={<RefreshVersion />} />
                <Route path="/apps/wedgefitting/setupinstructions" element={<SetupInstructions />} />
                <Route path="/apps/wedgefitting/tmlog" element={<TMLog />} />
            </Routes>
        </div>
    );
}

export default App;
